import { t } from '@avalara/bat-apps-shared/i18n';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { selectState } from '../../../selectors';
import CybersourcePaymentPage from '../../cybersource-payment';
import ExistingPaymentMethodNotice from '../../shared/payment/existing-payment-method-notice';
import PaymentSelection from '../../shared/payment/payment-selection';
import AlreadyHaveAccount from '../already-have-account';

const TrialPaymentMethod = () => {
  const history = useHistory();

  const {
    account: { isLoggedIn, paymentMethods, selectedPaymentMethod },
    esb: { esbPartner, esbPath },
    features,
  } = useSelector(selectState);

  const isHighRadiusEnabled = !!features.ENABLEHIGHRADIUSMIGRATION;

  if (!esbPartner) return null;

  const goBack = () =>
    history.push({
      pathname: `/${esbPath}/${esbPartner}/company-info`,
      search: window.location.search,
    });

  const goToNextPage = () =>
    history.push({
      pathname: `/${esbPath}/${esbPartner}/create-login`,
      search: window.location.search,
    });

  const onClickNext = () => (selectedPaymentMethod ? goToNextPage() : undefined);

  if (isLoggedIn && isHighRadiusEnabled) {
    return (
      <>
        <h1>{t('client.headings.payment-method')}</h1>

        <ExistingPaymentMethodNotice />

        <hr className='pad-bottom-lg' />

        <button id='submit-payment' type='button' className='primary' onClick={goToNextPage}>
          {t('client.buttons.next')}
        </button>

        <button type='button' className='secondary margin-left-lg' onClick={goBack}>
          {t('client.buttons.back')}
        </button>
      </>
    );
  }

  return (
    <>
      <h1>{t('client.headings.add-a-credit-card')}</h1>

      <p>
        <AlreadyHaveAccount />
      </p>

      {!!paymentMethods.length && (
        <div className='margin-top-md'>
          <PaymentSelection />
        </div>
      )}

      {!selectedPaymentMethod && <CybersourcePaymentPage paymentView='add-credit-card' onSuccess={goToNextPage} />}

      <hr className='pad-bottom-lg' />

      <button id='submit-payment' type='button' className='primary' onClick={onClickNext}>
        {t('client.buttons.next')}
      </button>

      <button type='button' className='secondary margin-left-lg' onClick={goBack}>
        {t('client.buttons.back')}
      </button>
    </>
  );
};

export default TrialPaymentMethod;
